// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1wUCi","content":"RecentSearches_content__3na5t"};